import { useQuery } from 'react-query'

import { QUERY_KEYS } from 'src/constants'
import { userService } from 'src/services/user.service'

export const useAppAddressAndBalance = () => {
  return useQuery(
    [QUERY_KEYS.USER_ADDRESS_AND_BALANCE],
    () => userService.fetchAddressAndBalance(),
    { keepPreviousData: true },
  )
}
